import { Badge } from "rothzerg-ui";
import type { ProductBadge as ProductBadgeType } from "@/types/catalog";

const variantMap: Record<
  ProductBadgeType["type"],
  "default" | "destructive" | "success" | "warning" | "info"
> = {
  bestseller: "destructive",
  trending: "warning",
  "low-price": "warning",
  "online-only": "info",
  new: "info",
};

type ProductBadgeProps = {
  badge: ProductBadgeType;
};

export function ProductBadge({ badge }: ProductBadgeProps) {
  return (
    <Badge variant={variantMap[badge.type]} size="sm">
      {badge.label}
    </Badge>
  );
}
